import * as t from "io-ts";
import { decode } from "io-ts-promise";
import { createTrailerTypes } from "dora-contracts";

const { trailerT, trailersT } = createTrailerTypes({
  decimal: t.string,
});

export type Trailer = t.TypeOf<typeof trailerT>;
export const decodeTrailers = decode(trailersT);
